/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types'
import React from 'react'

export const ButtonEventType = {
  click: 'click',
  mouseUp: 'mouseUp',
}

function Button({
  id,
  event,
  text,
  title,
  variant,
  modifiers = [],
  disabled,
  disabledReason,
  eventType = ButtonEventType.click,
  type = 'button',
  testid,
  children,
}) {
  const buttonProps = {
    id,
    disabled,
    type,
  }

  if (eventType === ButtonEventType.click) {
    buttonProps.onClick = event
  } else if (eventType === ButtonEventType.mouseUp) {
    buttonProps.onMouseUp = event
  }

  const showDisabledReasonOnHover = disabled && disabledReason
  buttonProps.title = showDisabledReasonOnHover ? disabledReason : title

  const classNames = getClassNames(variant, modifiers)

  return (
    <div className={classNames}>
      <button {...buttonProps} data-testid={testid}>
        {children || text}
      </button>
    </div>
  )
}

Button.propTypes = {
  event: PropTypes.func,
  eventType: PropTypes.oneOf([ButtonEventType.click, ButtonEventType.mouseUp]),
  id: PropTypes.string,
  testid: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'primarydark', 'secondary', 'secondarydark', 'textonly']),
  modifiers: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  children: PropTypes.node,
}

function getClassNames(variant, modifiers) {
  let classNames = getVariantClassName(variant)
  modifiers.forEach(modifier => {
    classNames = `${classNames} button--${modifier}`
  })
  return classNames
}

function getVariantClassName(variant) {
  return variant ? `button button--${variant}` : 'button'
}

export default Button
